import { currentPrepStationsSelector } from './chunk-RO5AAHK3.mjs';

// src/helpers/factories/settings/kitchenTicketSettings/prepStationVersionsFactory.ts
var prepStationVersionsFactoryCore = (prepStationVersions, state) => {
  const prepStations = currentPrepStationsSelector(state);
  const prepStationIds = Object.values(prepStationVersions).map(
    (prepStationVersion) => prepStationVersion.prepStationId
  );
  return Object.values(prepStations).filter(
    (prepStation) => prepStationIds.includes(prepStation.id)
  );
};
var prepStationVersionsSelectionFactoryCore = (prepStationVersions, state) => {
  const prepStations = currentPrepStationsSelector(state);
  const prepStationIds = Object.values(prepStationVersions).map(
    (prepStationVersion) => prepStationVersion.prepStationId
  );
  return Object.values(prepStations).filter((prepStation) => prepStationIds.includes(prepStation.id)).map((prepStationVersion) => {
    return {
      name: prepStationVersion.posName,
      prepStationId: prepStationVersion.id,
      selected: false
    };
  });
};

export { prepStationVersionsFactoryCore, prepStationVersionsSelectionFactoryCore };
